<template>
  <div class="panel">
    <div class="panel-heading">
      <span v-if="yieldsForDate">Treasury bond yields as of <formatted-date :date="currentDate"/></span>
    </div>
    <div class="panel-body">
      <canvas ref="chart" :style="{height: '275px', width:'800px'}"></canvas>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import * as data from '../../../client/src/data.js'
  import FormattedDate from './FormattedDate'
  export default {
    components: {FormattedDate},
    props:{
      yieldsForDate: Array,
      currentDate: Date
    },
    data () {
      return {
        chart: null,
        options: {
          animation: false,
          maintainAspectRatio: false,
          legend: {display: false},
          title: {
            display: false,
          },
          elements: {
            point: {
              radius: 0
            }
          },
          scales: {
            xAxes: [{
              type: 'linear',
              display: true,

              ticks: {
                callback: value => data.DURATIONS.includes(value) && value % 12 === 0 ? value / 12 + 'y' : null,
                min: 0,
                max: 360,
                autoSkip: true,
                maxTicksLimit: 30,
                stepSize: 12,
                maxRotation: 0,
                minRotation: 0
              }
            }],
            yAxes: [{
              ticks: {
                min: 0,
                max: 10,
                callback: value => value.toFixed(1) + '%'
              }
            }]
          }
        }
      };
    },
    computed: {
      yieldData() {
        const yieldData = [];
        if(!this.yieldsForDate) return null;

        this.yieldsForDate.forEach((currentYield, i) => {
          if (data.isNumber(currentYield[0])) {
            yieldData.push({x: data.DURATIONS[i], y: currentYield[0]});
          }
        });
        return yieldData;
      },
    },
    watch: {
      yieldData(yields) {
        if (!yields) return;
        this.chart = new Chart(this.$refs.chart, {
          type: 'line',
          data: {
            datasets: [{
              data: yields,
              borderColor: '#4A87D0',
              borderWidth: '2',
              backgroundOpacity: '.3',
              backgroundColor: 'rgba(74,135,208, .5)'
            }]
          },
          options: this.options});
      }
    }
  }
</script>

<style>
  .small {
    height: 150px;
  }
</style>
